import { post } from '@eika-infrastruktur/request';

type LogLevel = 'debug' | 'info' | 'error' | 'warn';

class Logger {
    apiPath: string | null;

    constructor(apiPath: string | null) {
        this.apiPath = apiPath;
    }

    log<TData = unknown>(level: LogLevel, data: TData | string, rcid?: string): Promise<unknown> {
        if (this.apiPath === null) {
            return Promise.reject(new Error('Logger is not registered.'));
        }
        const payload = typeof data === 'string' ? { message: data } : data;
        const headers = rcid ? { headers: { 'X-Eika-RequestCorrelationId': rcid } } : undefined;
        return post(`${this.apiPath}/${level}`, payload, headers).catch(() => null);
    }
}

export default Logger;
